import React from 'react';

import _ from 'lodash';

import Input from 'components/Input';
import { ENUM_QUESTION_TYPE, ENUM_TYPE_OPTION } from 'constants/enum';
import useCreateSurvey from 'hooks/useCreateSurvey';
import { renderTitleIfChooseType } from 'utils/helper';

import { AddOptionButton } from './RadioCheckbox';

const RecursiOption = (props) => {
  const { onSaveStep } = useCreateSurvey();
  const { data, viewOnly, questionEditing, form, sectionIndex, questionIndex, isPreview, OptionalForm } = props;

  const handleChecked = (item) => {
    if (data.answer) {
      return _.findIndex(data.answer, (ans) => (_.isString(ans) ? ans === item.option_text : ans === item.id)) > -1;
    }
    return false;
  };

  return (
    <div className={`${!viewOnly && 'mt-2'}`}>
      {data?.options?.map((item, index) => (
        <div key={`recursion-option-${index}`}>
          <div className="flex items-center gap-2 mb-2">
            <Input
              readOnly
              checked={handleChecked(item)}
              name={data.id}
              type={[ENUM_QUESTION_TYPE.RADIO].includes(data.question_type) ? 'radio' : 'checkbox'}
              className={`w-4 h-4 flex-middle-center ${[ENUM_QUESTION_TYPE.RADIO].includes(data.question_type) ? 'radio-button' : 'checkbox-button'}`}
              classNameInput="min-w-4 min-h-4 border-0 bg-transparent border-b border-dashed !border-gray-102/65 text-gray-102/65 !p-0"
            />
            {questionEditing ? (
              <Input
                value={item?.option_text}
                onChange={form.handleChange}
                className="!h-auto w-full"
                classNameInput="w-full border-0 bg-transparent focus:border-b border-solid border-black-102 text-black-102 !py-0 !pb-1 !px-1"
                name={`sections[${sectionIndex}].questions[${questionIndex}].options[${index}.option_text]`}
                onBlur={() => onSaveStep(form.values)}
              />
            ) : (
              <span className="text-black-102 break-all">{item?.option_text || ''}</span>
            )}
          </div>
          {data.sub_questions.some((record) => record.active_condition === item.option_text) > 0 && (
            <div className={isPreview ? 'pl-2 my-1' : 'pl-6 my-3'} key={index}>
              <div className={`border border-solid border-gray-489 rounded-lg ${isPreview ? 'p-2' : 'p-6'}`}>
                <p className={`text-black-102 text-sm font-bold ${isPreview ? 'mb-1' : 'mb-6'}`}>{renderTitleIfChooseType(item.option_text)}</p>
                {data.sub_questions.map((sub, index) => {
                  if ([ENUM_QUESTION_TYPE.RADIO, ENUM_QUESTION_TYPE.CHECKBOX].includes(sub.question_type)) {
                    sub.options = _.map(sub.options, (item) => (_.isString(item) ? { option_text: item } : item));
                  }
                  sub.sub_questions = sub.child_questions;

                  if (sub.active_condition === item.option_text) {
                    const hasChildQuestions = sub?.child_questions?.length > 0;
                    return (
                      <div
                        className={`${hasChildQuestions ? (isPreview ? '-mb-1' : '-mb-5') : isPreview ? '-mb-1' : ''}`}
                        key={`sub-question-${index}`}
                      >
                        <OptionalForm {...props} data={sub} />
                      </div>
                    );
                  } else {
                    return <React.Fragment key={index}></React.Fragment>;
                  }
                })}
              </div>
            </div>
          )}
        </div>
      ))}
      {viewOnly ? <></> : <>{!isPreview && <AddOptionButton {...props} typeOption={ENUM_TYPE_OPTION.RADIO} />}</>}
    </div>
  );
};

export default RecursiOption;
